import script from "./report-chart.vue?vue&type=script&lang=ts&setup=true"
export * from "./report-chart.vue?vue&type=script&lang=ts&setup=true"

import "./report-chart.vue?vue&type=style&index=0&id=33234b54&lang=scss&scoped=true"

import exportComponent from "D:\\Projects\\WebStorm\\operation-platform\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-33234b54"]])

export default __exports__